import { extends as _extends } from '../../_virtual/_rollupPluginBabelHelpers.js';
import React from 'react';
import { _cs } from '@togglecorp/fujs';
import { genericMemo } from '../../utils/index.js';
import { TabContext } from '../TabContext.js';
import styles from './styles.css.js';

function TabList(props) {
  const {
    children,
    className,
    ellipsize = false,
    ...otherProps
  } = props;
  const {
    setEllipsize
  } = React.useContext(TabContext);
  React.useEffect(() => {
    setEllipsize(ellipsize);
  }, [setEllipsize, ellipsize]);
  return /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
    className: _cs(className, styles.tabList),
    role: "tablist"
  }), children);
}

var index = genericMemo(TabList);

export { index as default };
//# sourceMappingURL=index.js.map
